import { useState } from "react";
import { CalendarDays } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "./ui/popover";
import { Calendar } from "./ui/calendar";

const toIso = (d) => d.toLocaleDateString("en-CA");
const fromIso = (iso) => (iso ? new Date(`${iso}T12:00:00`) : undefined);
const inDays = (n) => {
  const d = new Date();
  d.setDate(d.getDate() + n);
  return toIso(d);
};
const nice = (iso) => fromIso(iso).toLocaleDateString("en-US", { weekday: "short", month: "short", day: "numeric" });

const QUICK = [["Tomorrow", 1], ["1 week", 7], ["2 weeks", 14], ["30 days", 30]];

export const FollowUpPicker = ({ lead, onUpdate }) => {
  const [open, setOpen] = useState(false);
  const save = (iso) => {
    setOpen(false);
    if ((iso || null) !== (lead.follow_up_date || null)) onUpdate(lead, { follow_up_date: iso || null });
  };
  const today = new Date();
  today.setHours(0, 0, 0, 0);

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button className={`h-9 w-full rounded-full border px-3 text-sm flex items-center gap-2 text-left transition-colors hover:border-blue-300 ${lead.follow_up_date ? "border-slate-200 text-slate-900" : "border-slate-200 text-slate-400"}`}
          data-testid="lead-followup-input">
          <CalendarDays className="h-4 w-4 text-blue-600 shrink-0" />
          <span className="truncate" data-testid="lead-followup-value">{lead.follow_up_date ? nice(lead.follow_up_date) : "Pick a date"}</span>
        </button>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-0 bg-white overflow-y-auto max-h-[var(--radix-popover-content-available-height)]"
        align="end" collisionPadding={8} data-testid="lead-followup-popover">
        <div className="grid grid-cols-2 gap-2 p-3 border-b border-slate-100">
          {QUICK.map(([label, n]) => (
            <button key={n} onClick={() => save(inDays(n))} data-testid={`lead-followup-quick-${n}`}
              className="h-10 rounded-full border border-slate-200 text-sm font-medium text-slate-700 hover:border-blue-400 hover:text-blue-700 transition-colors">
              {label}
            </button>
          ))}
        </div>
        <Calendar mode="single" selected={fromIso(lead.follow_up_date)} defaultMonth={fromIso(lead.follow_up_date)}
          onSelect={(d) => d && save(toIso(d))} disabled={{ before: today }} initialFocus
          className="[&_button]:h-10 [&_button]:w-10 [&_td]:p-0.5" data-testid="lead-followup-calendar" />
        {lead.follow_up_date && (
          <div className="p-3 pt-0">
            <button onClick={() => save(null)} className="w-full h-10 rounded-full text-sm font-medium text-red-600 hover:bg-red-50 transition-colors" data-testid="lead-followup-clear">
              Clear follow-up
            </button>
          </div>
        )}
      </PopoverContent>
    </Popover>
  );
};
